export default "__VITE_ASSET__tGD6aop2__"